import * as React from 'react';

import type { Eta } from '@klareospace/pharos-lib-types';
import { formatEventTimestampSafe } from '@klareospace/pharos-lib-front-utils';
import { TextCell } from '@klareospace/pharos-lib-web-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface EtaCellProps {
  eta?: Eta;
}

// ─── Component ────────────────────────────────────────────────────────────────

/** `eta.value` arrives as an ISO string over HTTP, not a real `Date` — parsed defensively here. */
export function EtaCell({ eta }: EtaCellProps): React.JSX.Element {
  return <TextCell>{formatEventTimestampSafe(eta?.value) ?? '—'}</TextCell>;
}
